import {
  SET_SKIN,
  UPDATE_SKIN
} from '../mutation-type'
import state from 'src/config/skins'

const mutations = {
  [SET_SKIN] (state, uid, skin) {
    state[uid] = skin
  },
  [UPDATE_SKIN] (state, skin) {
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/skins.js